/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MarkOwnHandbookAsReadMutationVariables = Types.Exact<{
  event_id: Types.Scalars["Int"];
}>;

export type MarkOwnHandbookAsReadMutation = {
  markOwnHandbookAsRead: Pick<Types.Volunteer, "read_handbook">;
};

export const MarkOwnHandbookAsReadDocument = gql`
  mutation MarkOwnHandbookAsRead($event_id: Int!) {
    markOwnHandbookAsRead(event_id: $event_id) {
      read_handbook
    }
  }
`;

/**
 * __useMarkOwnHandbookAsReadMutation__
 *
 * To run a mutation, you first call `useMarkOwnHandbookAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOwnHandbookAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOwnHandbookAsReadMutation, { data, loading, error }] = useMarkOwnHandbookAsReadMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useMarkOwnHandbookAsReadMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkOwnHandbookAsReadMutation,
    MarkOwnHandbookAsReadMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    MarkOwnHandbookAsReadMutation,
    MarkOwnHandbookAsReadMutationVariables
  >(MarkOwnHandbookAsReadDocument, baseOptions);
}
export type MarkOwnHandbookAsReadMutationHookResult = ReturnType<
  typeof useMarkOwnHandbookAsReadMutation
>;
export type MarkOwnHandbookAsReadMutationResult =
  ApolloReactCommon.MutationResult<MarkOwnHandbookAsReadMutation>;
export type MarkOwnHandbookAsReadMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    MarkOwnHandbookAsReadMutation,
    MarkOwnHandbookAsReadMutationVariables
  >;
